module.exports = __webpack_public_path__ + "static/media/brasil_icon.30dd0700.png";